<template>
    <div class="hypermode-container">
        <div class="card">
            <header class="header">
                <h1>{{ $t('hypermode.header') }}</h1>
            </header>

            <section class="section">
                <p class="text">
                    <strong class="text-hilight">{{ $t('hypermode.hypermodeLabel') }}</strong>
                    {{ $t('hypermode.description') }}
                </p>
                <p class="text">
                    <strong class="text-hilight">{{ $t('hypermode.noteLabel') }}</strong>
                    {{ $t('hypermode.note') }}
                </p>
            </section>

            <section class="section">

                <div class="d-flex flex-column justify-content-center align-items-center text-center">
                    <h2>{{ $t('hypermode.howToUse.title') }}</h2>
                    <p class="text">{{ $t('hypermode.howToUse.subtitle') }}</p>
                </div>

                <div class="pt-4">
                    <h3>{{ $t('hypermode.normal.title') }}</h3>

                    <div class="sub">
                        <h4>{{ $t('hypermode.normal.settingsLabel') }}</h4>
                        <h4 class="text">{{ $t('hypermode.normal.settingsDesc') }}</h4>
                        <ul class="text">
                            <li v-for="item in $t('hypermode.normal.settings')" :key="item">{{ item }}</li>
                        </ul>
                    </div>

                    <div class="sub">
                        <h4>{{ $t('hypermode.normal.stopLabel') }}</h4>
                        <p class="text">{{ $t('hypermode.normal.stopDescription') }}</p>
                    </div>

                    <div class="sub">
                        <h4>{{ $t('hypermode.normal.continue') }}</h4>
                        <p class="text">{{ $t('hypermode.normal.continueDesc') }}</p>
                    </div>

                    <div class="sub">
                        <h4>{{ $t('hypermode.normal.exit') }}</h4>
                        <p class="text">{{ $t('hypermode.normal.exitDesc') }}</p>
                    </div>
                </div>

                <div>
                    <h3>{{ $t('hypermode.feature.title') }}</h3>

                    <div class="sub">
                        <h4>{{ $t('hypermode.feature.selectedLabel') }}</h4>
                        <p class="text">{{ $t('hypermode.feature.selectedDesc') }}</p>
                    </div>

                    <div class="sub">
                        <h4>{{ $t('hypermode.feature.settingsLabel') }}</h4>
                        <ul class="text">
                            <li v-for="item in $t('hypermode.feature.settings')" :key="item">{{ item }}</li>
                        </ul>
                    </div>

                    <div class="sub">
                        <h4>{{ $t('hypermode.feature.costLabel') }}</h4>
                        <p class="text">{{ $t('hypermode.feature.costDesc') }}</p>
                        <div class="formula">{{ $t('hypermode.feature.formula') }}</div>
                    </div>
                </div>
            </section>

            <section class="section">
                <h2>{{ $t('hypermode.controls.title') }}</h2>
                <ul class="text">
                    <li v-for="item in $t('hypermode.controls.list')" :key="item">{{ item }}</li>
                </ul>
            </section>

            <section class="section">
                <h2>{{ $t('hypermode.summary.title') }}</h2>
                <p class="text">{{ $t('hypermode.summary.desc') }}</p>
                <ul class="text">
                    <li v-for="item in $t('hypermode.summary.list')" :key="item">{{ item }}</li>
                </ul>
            </section>

            <section class="section">
                <h2>{{ $t('hypermode.additional.title') }}</h2>
                <ul class="text">
                    <li v-for="item in $t('hypermode.additional.list')" :key="item">{{ item }}</li>
                </ul>
            </section>
        </div>
    </div>
</template>

<script>
export default {
    name: 'hypermode',
    data() {
        return {
        }
    },
    created() {
        const params = new URLSearchParams(window.location.search);
        const lang = params.get("lang");

        if (lang) {
            this.$i18n.locale = lang;
        } else {
            this.$i18n.locale = 'en';
            this.lang = 'en';
        }
    }
}
</script>

<style scoped>
.hypermode-container {
    display: flex;
    justify-content: center;
    background: #0D2536;
}

.card {
    width: 100%;
    background: #0D2536;
    color: #e6f2ff;
    padding: 40px;
}

.header h1 {
    color: #00e676;
    font-size: 3vw;
}

.section {
    margin-top: 20px;
}

h2 {
    color: #23DC6A;
    margin-bottom: 8px;
}

h3 {
    color: #23DC6A;
}

h4 {
    color: #23DC6A;
    margin-bottom: 6px;
}

.note {
    margin-top: 10px;
    color: #b3c7d6;
}

ul {
    padding-left: 20px;
}

.mode {
    margin-top: 16px;
    padding: 12px;
    border-radius: 10px;
    background: #0f2f47;
}

.sub {
    margin-top: 10px;
}

.option {
    margin-top: 10px;
    padding: 10px;
    background: #0D2536;
    border-radius: 8px;
}

.formula {
    /* margin-top: 10px; */
    margin: 5%;
    padding: 3%;
    text-align: center;
    background: #1E2B3C;
    border-radius: 12px;
    font-weight: bold;
    color: #FFD51F;
    font-size: 3vw;
}

.text {
    color: #CCCCCC;
    font-size: 2.5vw;
}

.text-hilight {
    color: #00e676;
}

.highlight {
    color: #ffd54f;
    font-weight: bold;
}

@media (max-width: 600px) {
    .card {
        padding: 14px;
    }

    .header h1 {
        font-size: 3vw;
    }
}
</style>
